export async function withLoading(vm, key, fn) {
  if (!vm.loadingStates) {
    vm.$set(vm, 'loadingStates', {});
  }

  vm.$set(vm.loadingStates, key, true);

  try {
    return await fn();
  } catch (error) {
    console.error(`Error during loading ${key}:`, error);
    throw error;
  } finally {
    vm.$set(vm.loadingStates, key, false);
  }
}
